module.exports = __webpack_public_path__ + "static/Trees-Landscape-Silhouette-e731663a07d1eea304c0e1e5ca35e252.png";